import React from 'react'
import TextLink from 'LuxKit/TextLink'
import styled from 'styled-components'
import useDoublePointsCampaignTier from '../hooks/useDoublePointsCampaignTier'

const SubtitleContainer = styled.div`


  &.bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.silver {
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.gold {
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`

function DoublePointTakeoverSubtitleContent() {
  const displayTier = useDoublePointsCampaignTier()
  return (
    <SubtitleContainer className={displayTier}>
      Double status credits on all hotels, tours and cruises! Limited time only. <TextLink wrap="no-wrap" to="/double-status-credits">View all offers</TextLink>
    </SubtitleContainer>
  )
}

export default DoublePointTakeoverSubtitleContent
